import * as actionTypes from './types';

const INITIAL_STATE: actionTypes.AuthState = {
  current: null,
  isLoggedIn: false,
  isLoading: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.GET_PROFILE_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isLoading: false,
        current: action.payload,
      };
    case actionTypes.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isLoading: false,
        current: action.payload,
      };
    case actionTypes.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isLoading: false,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isLoading: false,
      };
    case actionTypes.LOGOUT_SUCCESS:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default authReducer;
